import { NgModule } from '@angular/core';
import {IbPmtRiskfiedComponent} from './ib-risk-field.component';

@NgModule({

    declarations:[
        IbPmtRiskfiedComponent
    ],
    exports:[
        IbPmtRiskfiedComponent
    ],
    imports:[

    ]


})


export class IbPmtRiskifiedModule { }
export { IbPmtRiskfiedComponent} from './ib-risk-field.component';
